export const agentAttorneyMappingTo9142ASectionD = {
	name: 'Agent/Attorney Profile Form Mapping',
  machine_name: 'agent_attorney_9142A_profile_mapping',
  targetFormDetailName: 'Form ETA-9142A',
  targetSectionName: 'Attorney or Agent Information <br/>(if applicable)',
  targetSectionLabel: 'D',
	fields: [
    {
      profileFieldName: 'new_profile_individual_agent_type_id',
      formTargetField: 'd1_representation_type'
    },
    {
      profileFieldName: 'new_profile_individual_agent_last_name',
      formTargetField: 'd2_agent_last'
    },
    {
      profileFieldName: 'new_profile_individual_agent_first_name',
      formTargetField: 'd3_agent_first'
    },
    {
      profileFieldName: 'new_profile_individual_agent_middle_name',
      formTargetField: 'd4_agent_middle'
    },
    {
      profileFieldName: 'new_profile_individual_agent_address_1',
      formTargetField: 'd5_agent_address_1'
    },
    {
      profileFieldName: 'new_profile_individual_agent_address_2',
      formTargetField: 'd6_agent_address_2'
    },
    {
      profileFieldName: 'new_profile_individual_agent_city',
      formTargetField: 'd7_agent_city'
    },
    {
      profileFieldName: 'new_profile_individual_agent_state_id',
      formTargetField: 'd8_agent_state_id'
    },
    {
      profileFieldName: 'new_profile_individual_agent_zip',
      formTargetField: 'd9_agent_zip'
    },
    {
      profileFieldName: 'new_profile_individual_agent_country_id',
      formTargetField: 'd10_agent_country_id'
    },
    {
      profileFieldName: 'new_profile_individual_agent_province',
      formTargetField: 'd11_agent_province'
    },
    {
      profileFieldName: 'new_profile_individual_agent_phone',
      formTargetField: 'd12_agent_phone'
    },
    {
      profileFieldName: 'new_profile_individual_agent_phone_ext',
      formTargetField: 'd12_agent_phone_ext'
    },
    {
      profileFieldName: 'new_profile_individual_agent_firm_name',
      formTargetField: 'd15_agent_firm_name'
    },
    {
      profileFieldName: 'new_profile_individual_agent_email',
      formTargetField: 'd14_agent_email'
    },
    {
      profileFieldName: 'new_profile_individual_agent_firm_fein',
      formTargetField: 'd16_agent_firm_fein'
    },
    {
      profileFieldName: 'new_profile_individual_agent_bar_number',
      formTargetField: 'd17_agent_bar_number'
    },
    {
      profileFieldName: 'new_profile_individual_agent_court_state_id',
      formTargetField: 'd18_agent_court_state_id'
    },
    {
      profileFieldName: 'new_profile_individual_agent_court_name',
      formTargetField: 'd19_agent_court_name'
    }
  ]
};
